// generated from 10 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const newsFeedViewedSinceFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("news_feed_viewed_since_filter"),
  comparison_key: z.enum([
    "3", // 5 (50.00%)
    "5", // 4 (40.00%)
    "4", // 1 (10.00%)
  ]),
  display_name: z.string(),
  // undefined: 4 (40.00%), defined 6 (60.00%)
  raw_value: common.date.optional(),
  value: z.union([
    // number samples: 1 (10.00%)
    z.literal(1),
    // string samples: 9 (90.00%)
    common.date,
  ]),
  varies_by_app_group: z.literal(false),
});
